import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';

export const aptApiSlice = createApi({
    reducerPath: 'aptApiSlice',
	baseQuery,
	endpoints: () => ({}),
});
